import { gql } from "@apollo/client";

// Package-less update through the generic updateLens mutation (updateWebLens needs a package). Lens
// Central cuts a new version that inherits the current package; a published lens is reviewed again.
export const renameWebLens = gql`
    mutation renameWebLens(
        $lensId: ID!
        $lensName: String!
        $creatorRewardProgramEnrolled: Boolean
        $profileVisibility: Visibility
    ) {
        updateLens(
            input: {
                lensId: $lensId
                lensName: $lensName
                creatorRewardProgramEnrolled: $creatorRewardProgramEnrolled
                profileVisibility: $profileVisibility
            }
        ) {
            lens {
                id
                name
                status
            }
        }
    }
`;
